"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
var _CompletedContext = require("../CompletedContext");
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var _Figure = _interopRequireDefault(require("../Figure/Figure"));
var _ShrinkToFit = _interopRequireDefault(require("../ShrinkToFit/ShrinkToFit"));
require("./TaskImageClick.css");
var _excluded = ["top", "left"];
var ImageClickHotspot = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ImageClickHotspot, _React$Component);
  var _super = (0, _createSuper2.default)(ImageClickHotspot);
  function ImageClickHotspot(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ImageClickHotspot);
    _this = _super.call(this, props);
    _this.state = {
      selected: false
    };
    _this.onSelect = _this.onSelect.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(ImageClickHotspot, [{
    key: "onSelect",
    value: function onSelect() {
      if (!this.state.selected) {
        this.setState({
          selected: true
        });
        this.props.onMouseInteract();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$style = this.props.style,
        top = _this$props$style.top,
        left = _this$props$style.left,
        rest = (0, _objectWithoutProperties2.default)(_this$props$style, _excluded);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "imageclick-container",
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement("button", {
        key: this.props.index,
        disabled: this.props.disabled,
        className: "imageclick" + (this.props.selected ? " imageclick-selected" : "") + (this.props.correct ? " imageclick-correct" : "") + (this.props.disabled ? " noHover" : ""),
        id: "task-imageclick-button-" + this.props.index,
        name: "answerChoice".concat(this.props.index),
        tabIndex: "0",
        "aria-label": (this.props.selected ? this.props.correct ? "Correct: " : "Incorrect: " : "") + this.props.label,
        style: (0, _objectSpread2.default)({
          padding: "0px"
        }, rest),
        onClick: this.onSelect,
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 39) {
            // Right
            var index = _this2.props.index + 1;
            if (index >= _this2.props.totalItems) {
              index = 0;
            }
            document.getElementById("task-imageclick-button-" + index).focus();
          }
          if (e.keyCode === 37) {
            // Left
            var _index = _this2.props.index - 1;
            if (_index < 0) {
              _index = _this2.props.totalItems - 1;
            }
            document.getElementById("task-imageclick-button-" + _index).focus();
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: "absolute",
          left: "50%",
          top: "0%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "imageclick-hotspot-text",
        "aria-hidden": true,
        style: {
          opacity: this.props.selected ? "1" : "0",
          backgroundColor: this.props.correct ? "#228522" : "#c93f3c",
          width: this.props.correct ? "72px" : "80px"
        }
      }, this.props.correct ? "CORRECT" : "INCORRECT"))), /*#__PURE__*/_react.default.createElement("div", {
        style: (0, _objectSpread2.default)({
          pointerEvents: "none"
        }, rest),
        className: "button-inner"
      })));
    }
  }]);
  return ImageClickHotspot;
}(_react.default.Component);
var TaskImageClick = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(TaskImageClick, _React$Component2);
  var _super2 = (0, _createSuper2.default)(TaskImageClick);
  function TaskImageClick(props) {
    var _this3;
    (0, _classCallCheck2.default)(this, TaskImageClick);
    _this3 = _super2.call(this, props);
    _this3.state = props.state || {};
    if (!_this3.state.initialized) {
      _this3.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this3.state.completed = false;
      _this3.state.completed_hotspots = [];
      _this3.state.completed_hotspots.length = props.hotspots.length;
    }
    _this3.onMouseInteract = _this3.onMouseInteract.bind((0, _assertThisInitialized2.default)(_this3));
    return _this3;
  }
  (0, _createClass2.default)(TaskImageClick, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      var tally = 0;
      var completed = 0;
      for (var k = 0; k < this.props.hotspots.length; ++k) {
        if (this.props.hotspots[k].correct) {
          ++tally;
          if (this.state.completed_hotspots[k]) {
            ++completed;
          }
        }
      }
      if (tally === completed && !this.state.completed) {
        this.setState({
          completed: true
        });
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this4.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "onMouseInteract",
    value: function onMouseInteract(k) {
      this.setState(function (state, props) {
        var hotspots = state.completed_hotspots.slice();
        hotspots[k] = true;
        var completed = true;
        for (var i = 0; i < props.hotspots.length; ++i) {
          if (!hotspots[i]) {
            completed = false;
          }
        }
        var correct = props.hotspots[k].correct;
        var feedback = props.hotspots[k].feedback;
        return {
          completed_hotspots: hotspots,
          completed: completed,
          correct: correct,
          feedback: feedback,
          showModal: true
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      if (!this.props.children) {
        if (this.props.alt === undefined && !this.props.suppressErrors) {
          throw new Error("TaskImageClick: prop 'alt' must be specified along with 'picture'.");
        }
        if (this.props.details === undefined && !this.props.suppressErrors) {
          throw new Error("TaskImageClick: prop 'details' must be specified along with 'picture'.");
        }
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        className: "task task-imageclick " + (this.props.className || ""),
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement(_ShrinkToFit.default, {
        textAdjust: this.props.textAdjust
      }, this.props.children || /*#__PURE__*/_react.default.createElement(_Figure.default, {
        src: this.props.picture,
        alt: this.props.alt,
        srCaption: this.props.details,
        width: this.props.width || "560px"
      }), this.props.hotspots.map(function (v, k) {
        if (!v.label && !_this5.props.suppressErrors) {
          throw new Error("TaskImageClick: hotspot ".concat(k, " has no label."));
        }
        var bR = "4px";
        if (v.shape === "Circle") {
          bR = "50%";
        }
        return /*#__PURE__*/_react.default.createElement(ImageClickHotspot, {
          key: k,
          onMouseInteract: function onMouseInteract() {
            return _this5.onMouseInteract(k);
          },
          style: (0, _objectSpread2.default)({
            borderRadius: bR
          }, v.style),
          selected: _this5.state.completed_hotspots[k],
          correct: v.correct,
          index: k,
          totalItems: _this5.props.hotspots.length,
          label: v.label,
          disabled: _this5.state.completed
        });
      })), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showModal,
        correct: this.state.correct,
        onHide: function onHide() {
          _this5.setState({
            showModal: false
          });
        }
      }, this.state.feedback));
    }
  }]);
  return TaskImageClick;
}(_react.default.Component);
TaskImageClick.contextType = _CompletedContext.CompletedContext;
var _default = TaskImageClick;
exports.default = _default;